<template>
  <nav class="yd-flex-center">
    <div
      class="nav-inner inner-media-width yd-display-flex yd-justifyContent-s"
    >
      <div class="inner-left yd-flex-c">
        <a
          @click="$router.push('/')"
          href="javascript:;"
          style="align-self: center"
        >
          <img class="logo" src="../../../assets/images/logo.png" />
        </a>
        <ul class="yd-flex-c">
          <li
            @mouseenter="navLiEnterEvent(item)"
            @mouseleave="navLiLeaveEvent(item)"
            @click="navLiClickEvent(index, item)"
            v-if="item.title"
            v-for="(item, index) in navbarData"
            :key="item.id"
            :class="{
              active: currentLiId == item.id,
              'yd-position-r': aboutSrId == item.id,
            }"
            class="yd-flex-c"
          >
            <span
              v-text="item.title"
              class="show-text"
              :class="{ bigArea: item.title.length <= 2 }"
            >
            </span>
            <!--关于森锐更多-->
            <transition name="yd-fade">
              <div
                @click.stop
                v-if="aboutSrId == item.id && aboutSrShow"
                class="about-sr-more yd-display-flex"
              >
                <div class="shadow" />
                <div class="more-left">
                  <div
                    @click="aboutSrSecondEvent(c, item)"
                    v-for="(c, i) in aboutSrSecondData.arrLeft"
                    :key="i"
                    :class="{ actived: c.actived }"
                    class="more-left-item yd-flex-center"
                  >
                    {{ c.navName }}
                  </div>
                </div>
                <!--<div class="more-right">-->
                <!--<div @click="aboutSrThirdEvent(c, item)" v-for="(c, i) in aboutSrSecondData.arrRight" :key="i" :class="{'actived': c.actived}" class="more-right-item">-->
                <!--{{c.navName}}-->
                <!--</div>-->
                <!--</div>-->
              </div>
            </transition>
            <!--产品-->
            <transition name="yd-fade">
              <div
                @click.stop
                v-if="productId == item.id && productShow"
                class="product-more yd-flex-center"
              >
                <div class="shadow"></div>
                <div
                  class="yd-display-flex yd-flexWrap-w"
                  style="width: 1100px"
                >
                  <div
                    @click="anchorPointEvent(c)"
                    v-for="(c, i) in productsData"
                    :key="i"
                    class="product-item yd-display-flex yd-flexDirection-c yd-alignItems"
                  >
                    <img
                      v-if="i == 0"
                      class="product-img"
                      src="../../../assets/images/product1.png"
                    />
                    <img
                      v-if="i == 1"
                      class="product-img"
                      src="../../../assets/images/product2.png"
                    />
                    <img
                      v-if="i == 2"
                      class="product-img"
                      src="../../../assets/images/product4.png"
                    />
                    <img
                      v-if="i == 3"
                      class="product-img"
                      src="../../../assets/images/product3.png"
                    />
                    <img
                      v-if="i == 4"
                      class="product-img"
                      src="../../../assets/images/product5.png"
                    />
                    <img
                      v-if="i == 5"
                      class="product-img"
                      src="../../../assets/images/product6.png"
                    />
                    <img
                      v-if="i == 6"
                      class="product-img"
                      src="../../../assets/images/product7.png"
                    />
                    <img
                      v-if="i == 7"
                      class="product-img"
                      src="../../../assets/images/product8.png"
                    />
                    <span v-text="c.product_name" />
                  </div>
                </div>
              </div>
            </transition>
          </li>
        </ul>
      </div>
      <div class="inner-right yd-flex-c">
        <span
          @click="loginEvent"
          style="cursor: pointer; position: relative; top: 4px"
          title="登录"
          >登录</span
        >
        <!--<img class="lang-icon" src="../../../assets/images/langIcon.png" />-->
        <!--<span><i style="color: #2E81E1;">中</i>丨<i @click="localhostHref" style="cursor: pointer">英</i></span>-->
      </div>
    </div>
  </nav>
</template>

<script>
import { checkRouter, isHref } from "@/utils";
import {
  navbar,
  navbarSeconds,
  navbarProductsSeconds,
  navbarsolutionSeconds,
} from "@/api/common";
export default {
  name: "navbar",
  data() {
    return {
      navbarData: [
        { title: "关于森锐", checked: false },
        { title: "产品", checked: false },
        { title: "解决方案", checked: false },
        { title: "支持与服务", checked: false },
        { title: "易售宝商城", checked: false },
        { title: "English", checked: false },
      ],
      navbarSeconds: {
        arr1: [],
        arr2: [],
      },
      // 关于森锐id
      aboutSrShow: false,
      aboutSrId: "337941841813049344",
      aboutSrSecondData: {
        arrLeft: [],
        arrRight: [],
      },
      thirdShowItemId: "",
      // 产品id
      productShow: false,
      productId: "337946599261081600",
      productsData: [],

      // 因为后台限制是必填，所以赋值为空字符串比较保险
      currentLiId: "",
      moreNavShow: "",
      // 这个是产品和解决方案的id
      specialArrId: ["337946599261081600", "338310004685803520"],
      pages: ["aboutSr", "products", "solution", "support", "joinUs"],
    };
  },
  watch: {
    $route() {
      let currentRouter = this.$route.path;
      for (var i = 0; i < this.pages.length; i++) {
        if (currentRouter.indexOf(this.pages[i]) !== -1) {
          break;
        }
      }
      if (i === this.pages.length) {
        this.currentLiId = "";
        this.moreNavShow = "";
      }
    },
  },
  mounted() {
    this.getNavbarData();
    this.getProductEvent();
  },
  methods: {
    // 获取解决方案的二级
    getSolutionNavEvent(item) {
      navbarsolutionSeconds().then((res) => {
        if (res.data.code === 0) {
          this.navbarSeconds.arr1 = res.data.data.slice(0, 6);
          this.navbarSeconds.arr2 = res.data.data.slice(6);
          if (res.data.data.length) {
            this.moreNavShow = item.id;
          }
        } else {
          this.$notify.error({
            title: "数据获取异常",
            message: res.config.url,
          });
        }
      });
    },
    // 详情
    navLiDetail(obj) {
      if (!isHref(obj.navUrl)) {
        if (checkRouter(obj.navUrl)) {
          this.$router.push(obj.navUrl);
        }
      }
    },

    localhostHref() {
      window.open("http://www.sunrizetech.net/", "_blank");
    },
    // 移入
    navLiEnterEvent(item) {
      if (item.id == this.aboutSrId) {
        this.aboutSrShow = true;
      }
      if (item.id == this.productId) {
        this.productShow = true;
      }
    },
    // 移出
    navLiLeaveEvent() {
      this.aboutSrShow = false;
      this.productShow = false;
    },
    // navbar点击
    navLiClickEvent(index, item) {
      if (!isHref(item.navUrl)) {
        if (checkRouter(item.navUrl)) {
          this.currentLiId = item.id;
          this.$router.push(item.navUrl);
        }
      }
    },
    // 获取导航数据
    getNavbarData() {
      let _this = this;
      navbar({ type: 1 }).then((res) => {
        if (res.data.code === 0) {
          res.data.data.forEach((item) => {
            item.title = item.navName;
          });
          _this.navbarData = res.data.data;
          // 刷新Li状态(这里还不够动态,有待优化)
          let pages = _this.pages;
          let currentRouter = this.$route.path;
          let chooseRouter = "";
          pages.forEach((item) => {
            if (currentRouter.indexOf(item) !== -1) {
              chooseRouter = item;
            }
          });
          _this.navbarData.forEach((item) => {
            if (chooseRouter && item.navUrl.indexOf(chooseRouter) !== -1) {
              _this.currentLiId = item.id;
            }
            // 获取关于森锐二级
            if (item.id == _this.aboutSrId) {
              _this.getAboutSrEvent();
            }
            // 获取产品二级
            if (item.id == _this.productId) {
              _this.getProductEvent();
            }
          });
        } else {
          _this.$notify.error({
            title: "数据获取异常",
            message: res.config.url,
          });
        }
      });
    },
    // 获取关于森锐的二级
    getAboutSrEvent() {
      navbarSeconds({ type: 1, pid: this.aboutSrId }).then((res) => {
        if (res.data.code === 0) {
          // 标识
          res.data.data.forEach((item, index) => {
            item.actived = false;
            if (item.children && item.children.length) {
              item.children.forEach((child, idx) => {
                child.actived = false;
              });
            }
          });
          // 赋值
          this.aboutSrSecondData.arrLeft = res.data.data;
          if (
            res.data.data[0] &&
            res.data.data[0].children &&
            res.data.data[0].children.length
          ) {
            this.aboutSrSecondData.arrRight = res.data.data[0].children;
          } else {
            this.aboutSrSecondData.arrRight = [];
          }
        } else {
          _this.$notify.error({
            title: "数据获取异常",
            message: res.config.url,
          });
        }
      });
    },
    // 关于森锐二级点击
    aboutSrSecondEvent(item, parent) {
      this.aboutSrSecondData.arrLeft.forEach((child) => {
        child.actived = false;
      });
      item.actived = true;
      if (false) {
        // 有三级
        item.children.forEach((child) => {
          child.actived = false;
          if (this.thirdShowItemId == child.id) {
            child.actived = true;
          }
        });
        this.aboutSrSecondData.arrRight = item.children;
      } else {
        // 没有三级
        if (!isHref(item.navUrl)) {
          if (checkRouter(item.navUrl)) {
            if (item.navUrl != this.$route.path) {
              this.$router.push(item.navUrl);
              this.aboutSrSecondData.arrRight = [];
              this.thirdShowItemId = "";
              this.currentLiId = parent.id;
            }
          }
        }
      }
      this.$forceUpdate();
    },
    // 关于森锐三级点击
    aboutSrThirdEvent(item, parent) {
      this.currentLiId = parent.id;
      this.aboutSrSecondData.arrRight.forEach((child) => {
        child.actived = false;
      });
      item.actived = true;
      this.thirdShowItemId = item.id;
      if (!isHref(item.navUrl)) {
        if (checkRouter(item.navUrl)) {
          if (item.navUrl != this.$route.path) {
            this.$router.push(item.navUrl);
          }
        }
      }
      this.$forceUpdate();
    },
    // 获取产品的二级
    getProductEvent() {
      navbarProductsSeconds().then((res) => {
        if (res.data.code === 0) {
          this.productsData = res.data.data.slice(0, 4);
          console.log(this.productsData);
        } else {
          this.$notify.error({
            title: "数据获取异常",
            message: res.config.url,
          });
        }
      });
    },
    // 产品的锚点事件
    anchorPointEvent(item) {
      this.currentLiId = this.productId;
      this.$root.Bus.$emit("page-anchor-point", item);
      if (this.$route.path != "/mould/products/productsDetail") {
        this.$router.push({
          path: "/mould/products/productsDetail",
          query: { productItem: JSON.stringify(item) },
        });
      }
    },
    // 登录
    loginEvent() {
      if (window.ActiveXObject || "ActiveXObject" in window) {
        this.$confirm(
          "为了更好的浏览效果，请前往其他浏览器打开（" +
            "http://www.sunrizetech.com/admin/" +
            "）",
          "温馨提示",
          {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning",
          }
        );
      } else {
        window.open("http://www.sunrizetech.com/admin/", "_blank");
      }
    },
  },
};
</script>

<style scoped>
nav {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  background: #fff;
  z-index: 100;
  border-bottom: 1px solid #eee;
}
.nav-inner {
  width: 1200px;
  height: 64px;
}
.nav-inner .inner-left a .logo {
  width: 104.27px;
  height: 44px;
}
.nav-inner .inner-left ul {
  margin-left: 42px;
  line-height: 1;
  height: 64px;
}
.nav-inner .inner-left ul li {
  font-size: 15px;
  font-weight: 400;
  height: 100%;
  cursor: pointer;
  box-sizing: border-box;
  margin-left: 44px;
  color: #333333;
  line-height: 1;
  text-stroke: 0.20000000298023224 rgba(51, 51, 51, 1);
  border-bottom: 3px solid transparent;
}
.nav-inner .inner-left ul li.active {
  border-bottom: 3px solid #2e81e1;
}
.nav-inner .inner-left ul li .show-text {
  display: inline-block;
  margin-top: 8px;
  position: relative;
}
.nav-inner .inner-left ul li .show-text.bigArea:after {
  content: "";
  display: inline-block;
  background: transparent;
  position: absolute;
  top: 0;
  left: -20px;
  width: 70px;
  height: 50px;
}
.nav-inner .inner-left ul li:hover {
  border-bottom: 3px solid #2e81e1;
}
.nav-inner .inner-left ul li:hover .show-text,
.nav-inner .inner-left ul li.active .show-text {
  color: #2e81e1;
}
.nav-inner .inner-right {
  font-size: 15px;
  font-weight: 400;
  line-height: 20px;
  color: rgba(51, 51, 51, 1);
  text-stroke: 0.20000000298023224 rgba(51, 51, 51, 1);
}
.nav-inner .inner-right .lang-icon {
  width: 20px;
  height: 20px;
  margin-left: 22px;
  margin-right: 4px;
}
/*新的更多*/
.about-sr-more {
  position: absolute;
  top: 106%;
  left: -52px;
  z-index: 100;
  background: #fff;
  width: 164px;
  /*height: 264px;*/
  border-left: 1px solid #eee;
  border-right: 1px solid #eee;
  border-bottom: 1px solid #eee;
}
.about-sr-more .more-left {
  width: 164px;
  height: 100%;
  box-sizing: border-box;
  padding-top: 12px;
  padding-bottom: 12px;
  border-right: 1px solid #eee;
}
.about-sr-more .more-left .more-left-item {
  height: 40px;
  font-size: 15px;
  color: rgba(51, 51, 51, 1);
  border-right: 3px solid transparent;
}
.about-sr-more .more-left .more-left-item:hover {
  color: #2e81e1;
  border-right: 3px solid #2e81e1;
}
.about-sr-more .more-left .more-left-item.actived {
  color: #2e81e1;
  border-right: 3px solid #2e81e1;
}
.about-sr-more .more-right {
  width: 240px;
  height: 100%;
  box-sizing: border-box;
  border-left: 1px solid #eeeeee;
  padding: 34px 8px 0 24px;
}
.about-sr-more .more-right .more-right-item {
  width: fit-content;
  font-size: 14px;
  color: rgba(102, 102, 102, 1);
  margin-bottom: 14px;
  border-bottom: 1px solid #fff;
}
.about-sr-more .more-right .more-right-item:hover {
  color: #2e81e1;
  border-bottom: 1px solid #2e81e1;
}
.about-sr-more .more-right .more-right-item.actived {
  color: #2e81e1;
  border-bottom: 1px solid #2e81e1;
}
.product-more {
  position: absolute;
  top: 100%;
  z-index: 100;
  width: 100%;
  background: #fff;
  min-height: 218px;
  left: 0;
  box-sizing: border-box;
  overflow: hidden;
  border-bottom: 1px solid #eee;
  padding-top: 44px;
}
.product-more .product-item {
  width: 25%;
  font-size: 15px;
  font-weight: 400;
  color: rgba(51, 51, 51, 1);
  margin-bottom: 44px;
}
.product-more .product-item .product-img {
  width: 128px;
  height: 128px;
  margin-bottom: 10px;
}
.product-more .product-item:hover {
  color: #2e81e1;
}
.shadow {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 10px;
  background: linear-gradient(
    180deg,
    rgba(0, 0, 0, 0.06) 0%,
    rgba(0, 0, 0, 0) 100%
  );
}

/*nav-more*/
.nav-more {
  position: absolute;
  top: 100%;
  z-index: 100;
  width: 100%;
  background: #fff;
  height: 0;
  left: 0;
  box-sizing: border-box;
  overflow: hidden;
  transition: all 0.5s;
  opacity: 0;
  border-top: 2px solid #f5f5f5;
}
.nav-more.height-auto {
  height: auto;
  opacity: 1;
}
.nav-more .nav-more-menu {
  background: #fff;
  width: 100%;
  height: 300px;
}
.nav-more .nav-more-menu .menu-content {
  width: 1200px;
  margin: 0 auto;
}
.nav-more.menu1 .nav-more-menu .menu-content .image-box {
  background: url("../../../assets/images/navImage.png");
  background-size: cover;
  width: 513px;
  height: 300px;
  margin-right: 50px;
}
.image-box h1 {
  font-size: 28px;
  font-weight: 900;
  color: #333333;
  margin-bottom: 10px;
}
.image-box .progress {
  width: 260px;
  height: 3px;
  background: #f5f5f5;
  border-radius: 10px;
  margin-bottom: 10px;
}
.image-box .progress div {
  width: 50%;
  height: 100%;
  background: #145b30;
}
.image-box p {
  font-size: 20px;
  color: #666666;
}
.nav-more.menu1 .nav-more-menu .menu-content .company-text {
  box-sizing: border-box;
  padding-top: 20px;
  margin-left: 20px;
}
.nav-item {
  margin-bottom: 24px;
}
div.company-text-t:first-child {
  margin-right: 38px;
}
.company-text h4 {
  font-weight: 400;
  color: #333333;
  font-size: 20px;
  margin-bottom: 12px;
}
.company-text p span {
  color: #666666;
  font-size: 16px;
  margin-right: 20px;
}
.t-h4 {
  height: 22px;
  margin-bottom: 12px;
}
.p-item {
  font-size: 14px;
  color: #666666;
  margin-bottom: 8px;
}
.p-item span:hover {
  color: #2e81e1;
}
.three:hover {
  color: #2e81e1;
}
.p-item img {
  width: 14px;
  height: 14px;
}
.yd-fade-enter-active,
.fade-leave-active {
  transition: opacity 0.28s;
}
.yd-fade-enter,
.yd-fade-leave-active {
  opacity: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/myHeader/components/navbar.vue